export default __webpack_public_path__ + "static/media/semsPlusPlus_en.21bd07a0.png";